import { DependencyList } from 'react';
import { HotkeyCallback, Options } from 'react-hotkeys-hook';
import { KeyboardScope } from '@/platform/shortcuts/operator-shortcuts';
import { TrackingProperties } from '@/utils/analytics/base-reporter';
import { useIsFocused } from '@react-navigation/native';
import { useKeyboardShortcuts } from '@platform/shortcuts/hooks/use-keyboard-shortcuts';

/**
 * Operator Portal wrapper for useKeyboardShortcuts that automatically
 * disables shortcuts when the screen loses focus.
 *
 * This prevents shortcuts from firing on stale screens that remain
 * mounted in the navigation stack (e.g., when navigating between tabs).
 */
export const useOperatorKeyboardShortcuts = (
  hotKey: string | string[],
  callback: HotkeyCallback,
  dependencies: Options | DependencyList,
  trackingData: TrackingProperties = {},
  enabled = true,
  scope?: KeyboardScope | string,
) => {
  const isPageFocused = useIsFocused();

  useKeyboardShortcuts(
    hotKey,
    callback,
    dependencies,
    trackingData,
    isPageFocused && enabled,
    scope,
  );
};
